import React, { ReactElement, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import * as Middleware from "@middlewares/index";
import { useDispatch } from "react-redux";
import AvatarEditor from "react-avatar-editor";

import Style from "./AvaChanger.module.scss";

const AvatarChanger = (data: { image: string }): ReactElement => {
  const dispatch = useDispatch();

  const [avaRef, setAvaRef] = useState<any>(React.createRef());

  const [image, setImage] = useState<any>(null);
  const [scale, setScale] = useState(1);
  useEffect(() => {
    convertToFile().then(setImage);
  }, [dispatch]);

  const convertToFile = async (): Promise<any> => {
    fetch(data.image)
      .then((res) => res.blob())
      .then((blob) => {
        setImage(new File([blob], "File name", { type: "image/png" }));
      });
  };

  const saveAvatar = () => {
    const canvas = avaRef.getImage().toDataURL();
    fetch(canvas)
      .then((res) => res.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          const base64data = reader.result;
          Middleware.Profile.avatar(String(base64data)).then(() => {
            Middleware.Ui.Modal.close();
          });
        };
      });
    Middleware.Ui.Modal.close();
  };

  if (!image) {
    return <></>;
  }
  return (
    <>
      <div className="modal modal--netw-soon">
        <div className="modal__header">
          <div className="modal__title">Изменить аватар</div>
          <button
            className="modal__close"
            onClick={() => {
              Middleware.Ui.Modal.close();
            }}
          />
        </div>
        <div className="modal__body">
          <div className={Style.editor}>
            <AvatarEditor
              ref={setAvaRef}
              image={image}
              borderRadius={150}
              border={0}
              color={[255, 255, 255, 0.8]} // RGBA
              scale={scale}
              rotate={0}
              className="editor"
            />
          </div>
          <div className="modal__desc">Вы можете перемещать изображение</div>
          <div className={Style.range}>
            <label className="label-range">Размер</label>
            <input
              type="range"
              min={1}
              max={4}
              step={0.1}
              value={Number(scale)}
              name="avScale"
              onChange={(e) => setScale(Number(e.target.value))}
            />
          </div>
          <div className={Style.buttons}>
            <Link
              className="btn btn--grey"
              to="#"
              onClick={(e) => {
                e.preventDefault();
                Middleware.Ui.Modal.close();
              }}
            >
              Отменить
            </Link>
            <Link
              className="btn btn--red"
              to="#"
              onClick={(e) => {
                e.preventDefault();
                saveAvatar();
              }}
            >
              Сохранить
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default AvatarChanger;
